export const formatDisplayDate = (
  date: Date | string | number,
  options?: Intl.DateTimeFormatOptions,
): string => {
  const d = date instanceof Date ? date : new Date(date);
  const isRtl = document.documentElement.dir === 'rtl';
  const locale = isRtl ? 'ar-u-nu-latn' : (navigator.language || 'en-US');

  return new Intl.DateTimeFormat(locale, options ?? {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
};
